/* DUZIT.EXE: local UI only. Product navigation and Shopify forms remain native. */
document.addEventListener('DOMContentLoaded', () => {
  const clocks = document.querySelectorAll('[data-reunion-time]');
  const updateTime = () => { const time = new Intl.DateTimeFormat('fr-FR', {timeZone:'Indian/Reunion',hour:'2-digit',minute:'2-digit'}).format(new Date()); clocks.forEach(el => {el.textContent=time;}); };
  updateTime(); if (clocks.length) setInterval(updateTime,30000);
  const start = document.querySelector('[data-start-toggle]');
  const menu = document.querySelector('#duzit-start-menu');
  const closeStart = () => { if(menu) menu.hidden=true; start?.setAttribute('aria-expanded','false'); };
  start?.addEventListener('click', () => { const open = menu.hidden; menu.hidden=!open; start.setAttribute('aria-expanded',String(open)); });
  menu?.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeStart));
  document.addEventListener('pointerdown', e=>{if(menu && !menu.contains(e.target) && !start?.contains(e.target))closeStart();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape' && menu && !menu.hidden){closeStart();start?.focus();}});
});

/* Deux clins d’œil de bureau ; aucune interruption du panier. */
document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.querySelector('[data-retro-joke]');
  if (!dialog) return;
  const zone = document.querySelector('[data-siesta-zone]');
  let returnFocus = null, timer = null, siestaSeen = false;
  try { siestaSeen = sessionStorage.getItem('duzit_siesta_21') === 'yes'; } catch (_) {}
  const jokes = {
    siesta: { file:'GATO.EXE', title:'GATO ne répond plus.', message:'Motif : sieste en cours. Merci de respecter les horaires de repos.', code:'CODE : SIESTE_974', button:'Le laisser dormir', icon:'💤' },
    secret: { file:'CONFIDENTIEL.TXT', title:'Tu as ouvert le fichier.', message:'Il s’appelait pourtant NE_PAS_OUVRIR. Pour les prochains drops, il va falloir patienter… Bien essayé.', code:'NIVEAU DE CURIOSITÉ : 100 %', button:'Refermer discrètement', icon:'📂' }
  };
  const close = () => { dialog.hidden=true; const target=returnFocus; returnFocus=null; if(target?.isConnected)target.focus({preventScroll:true}); };
  const show = (key, trigger) => {
    if (!dialog.hidden) return;
    const joke=jokes[key];
    dialog.querySelector('[data-joke-file]').textContent=joke.file;
    dialog.querySelector('#retro-joke-title').textContent=joke.title;
    dialog.querySelector('#retro-joke-message').textContent=joke.message;
    dialog.querySelector('[data-joke-code]').textContent=joke.code;
    dialog.querySelector('[data-joke-dismiss]').textContent=joke.button;
    dialog.querySelector('.retro-joke__icon').textContent=joke.icon;
    returnFocus=trigger||null;dialog.hidden=false;
    if(trigger)dialog.querySelector('[data-joke-close]').focus({preventScroll:true});
  };
  zone?.addEventListener('pointerenter', e=>{
    if(e.pointerType!=='mouse'||siestaSeen)return;
    timer=setTimeout(()=>{if(document.hidden||!dialog.hidden)return;siestaSeen=true;try{sessionStorage.setItem('duzit_siesta_21','yes');}catch(_){}show('siesta');},900);
  });
  zone?.addEventListener('pointerleave',()=>clearTimeout(timer));
  document.querySelectorAll('[data-joke-trigger]').forEach(button=>button.addEventListener('click',()=>show(button.dataset.jokeTrigger,button)));
  dialog.querySelector('[data-joke-close]').addEventListener('click',close);
  dialog.querySelector('[data-joke-dismiss]').addEventListener('click',close);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!dialog.hidden)close();});
  document.addEventListener('pointerdown',e=>{if(!dialog.hidden&&!dialog.contains(e.target)&&!e.target.closest('[data-joke-trigger]'))close();});
});

/* Fenêtres de côté : fermables, sans collecte ni envoi externe. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-side-window]').forEach(panel=>{
    const key='duzit_side_22_'+panel.dataset.sideWindow;
    try{if(sessionStorage.getItem(key)==='closed')panel.hidden=true;}catch(_){}
    const dismiss=()=>{panel.hidden=true;panel.dataset.dismissed='true';try{sessionStorage.setItem(key,'closed');}catch(_){} };
    panel.querySelector('[data-side-close]')?.addEventListener('click',dismiss);
    panel.querySelector('[data-side-accept]')?.addEventListener('click',dismiss);
    panel.addEventListener('keydown',e=>{if(e.key==='Escape'){dismiss();document.querySelector('.secret-file')?.focus({preventScroll:true});}});
  });
  document.querySelector('[data-send-miaou]')?.addEventListener('click',e=>{
    const panel=e.currentTarget.closest('[data-side-window]');
    panel.querySelector('[data-miaou-status]').textContent='Miaou envoyé. GATO ne répond toujours pas. Très professionnel.';
    e.currentTarget.textContent='GATO dort toujours…';e.currentTarget.disabled=true;
  });
});

/* Une notification façon messagerie des années 2000, au bord du bureau. */
document.addEventListener('DOMContentLoaded',()=>{
  const panel=document.querySelector('[data-msn-window]');if(!panel)return;
  const messages=[
    'Tu peux garder un œil sur la boutique ? Je ferme les deux miens.',
    'Je pars me reposer. Si Teri demande, je suis en réunion.',
    'J’ai mis mon statut « occupé ». Je suis occupé à rien faire.'
  ];
  panel.querySelector('[data-msn-message]').textContent=messages[Math.floor(Math.random()*messages.length)];
  panel.querySelector('[data-msn-title]').textContent='NOUVEAU MESSAGE · GATO';
  const wide=matchMedia('(min-width:1280px)');let timer=null;
  let closed=false;try{closed=sessionStorage.getItem('duzit_side_22_messenger')==='closed';}catch(_){}
  if(closed)return;
  if(wide.matches){
    panel.hidden=true;
    const schedule=()=>{
      if(document.hidden||!document.body.classList.contains('duzit-shop-open')||timer||panel.dataset.dismissed==='true')return;
      timer=setTimeout(()=>{timer=null;if(panel.dataset.dismissed==='true')return;if(!document.hidden&&document.body.classList.contains('duzit-shop-open')){panel.hidden=false;panel.classList.add('msn-arrival');}},7000);
    };
    schedule();window.addEventListener('hashchange',schedule);document.addEventListener('visibilitychange',schedule);new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['class']});
    wide.addEventListener('change',e=>{if(!e.matches){clearTimeout(timer);timer=null;let dismissed=false;try{dismissed=sessionStorage.getItem('duzit_side_22_messenger')==='closed';}catch(_){}if(!dismissed)panel.hidden=false;}});
  }
});

/* Deux pattes en quelques poses, comme une petite animation stop motion. */
document.addEventListener('DOMContentLoaded',()=>{
  const paws=[...document.querySelectorAll('[data-cat-paw]')];
  const frame=document.querySelector('.drop-intro');
  if(paws.length!==2||!frame)return;
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  let next=0,wait=null,impact=null,current=null;
  const eligible=()=>!motion.matches&&!document.hidden&&document.body.classList.contains('duzit-shop-open');
  const reset=()=>{clearTimeout(wait);clearTimeout(impact);wait=null;current?.cancel();current=null;paws.forEach(p=>p.hidden=true);};
  const schedule=(delay=28300)=>{if(eligible()&&!wait&&!current)wait=setTimeout(play,delay);};
  function play(){
    wait=null;if(!eligible())return;
    const box=frame.getBoundingClientRect();
    if(box.bottom<145||box.top>innerHeight-140){schedule();return;}
    const paw=paws[next++%2],left=paw.dataset.catPaw==='left';
    const edge=left?box.left:innerWidth-box.right;
    // Keep the cut base beyond the viewport, including wide desktop margins.
    const width=Math.max(innerWidth<=600?112:235,(edge+24)/.86);
    const height=width*887/1774;
    const top=Math.max(145,Math.min(box.top+box.height*(left?.27:.73)-height/2,innerHeight-height-65));
    paw.style.width=width+'px';paw.style.top=top+'px';
    const end=left?box.left-width*.86:-(innerWidth-box.right-width*.86);
    const outside=left?-width-8:width+8;
    const pull=left?-18:18;
    paw.hidden=false;
    const poses=[[0,outside],[.18,outside*.6],[.33,end+pull*2],[.44,end+pull],[.50,end],[.57,end+pull],[.65,end],[.72,end+pull],[.80,end],[.88,end+pull*2],[1,outside]];
    current=paw.animate(poses.map(([offset,x])=>({offset,transform:'translateX('+x+'px)',easing:'steps(1,end)'})),{duration:1700,easing:'linear',fill:'both'});
    impact=setTimeout(()=>{if(eligible())frame.animate([{transform:'translateX(0)'},{transform:'translateX('+(left?2:-2)+'px)'},{transform:'translateX(0)'}],{duration:230,easing:'steps(2,end)'});},850);
    const animation=current;animation.finished.catch(()=>{}).finally(()=>{paw.hidden=true;animation.cancel();if(current===animation)current=null;schedule();});
  }
  schedule(30000);
  new MutationObserver(()=>{if(!eligible())reset();else schedule(30000);}).observe(document.body,{attributes:true,attributeFilter:['class']});
  document.addEventListener('visibilitychange',()=>{if(!eligible())reset();else schedule(30000);});
  window.addEventListener('hashchange',()=>{if(!eligible())reset();else schedule(30000);});
  window.addEventListener('resize',()=>{reset();schedule(30000);});
  motion.addEventListener('change',()=>{reset();if(!motion.matches)schedule(30000);});
});

